import _4 from 'lodash4';

/**
 * renders row template for vi-list in ai-template-entity-filter-table-selections
 */
window['$ip'].require('@eab-pip/pi-adt');
window['$ip'].require('@eab-hip/lit-html');

class CourseSearchResults {
  id = 'course-search-results';

  render({ bulkActionsTmplFn }) {
    return (_entity, index) => {
      const adt = window['$ip'].use('@eab-pip/pi-adt');
      const { html, nothing } = window['$ip'].use('@eab-hip/lit-html');
      const entityMutation = adt.mutation('entity');
      const bulkActionsTmpl = bulkActionsTmplFn(_entity, index);
      const entity = entityMutation.invoke(_entity);
      const courseCode = entity.cd;
      const courseTitle = entity.title;
      const courseCredits = entity.credits ? entity.credits : 0;
      const numberOfSections = entity.number_of_sections ? entity.number_of_sections : 0;

      return html` ${this.__renderStyles()}
        <li class="pl-5 pr-5" kind="no-dot" data-index=${index}>
          <section
            class="pt-5 pb-5 bb-1 bdr-solid clr-gray_40-bdr"
            l-kind="hort"
            l-width-fixed
            l-no-wrap
            l-align="center"
            l-justify="between"
          >
            ${bulkActionsTmpl ? bulkActionsTmpl : nothing}
            <div class="pl-4" l-kind="vert">
              <span class="filtered-result-item" allow-ellipsis>${courseCode} : ${courseTitle}</span>
              <span class="mt-3">Credits: ${courseCredits}</span>
              <span class="mt-3">Number of Sections: ${numberOfSections}</span>
            </div>
          </section>
        </li>`;
    };
  }

  private __renderStyles() {
    const { html } = window['$ip'].use('@eab-hip/lit-html');
    return html`
      <style>
        .filtered-result-item {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          white-space: normal;
        }
      </style>
    `;
  }
}

const view = new CourseSearchResults();

window['$ip'].include('cached://search_results_list_template', view);

export default view;



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/components/search_and_add_courses/search_results_list_template.ts